import { prefetchModelShow } from '@rhino-project/core/hooks';
import { NotFoundPage } from '@rhino-project/ui-heroui';
import { createFileRoute } from '@tanstack/react-router';
import ReportPage from '../../../../pages/reports/ReportPage';

export const Route = createFileRoute('/_authenticated/$owner/reports/$id/')({
  loader: ({ context: { rhino }, params: { id } }) => {
    return prefetchModelShow(rhino, 'report', id);
  },
  component: RouteComponent,
  notFoundComponent: NotFoundPage
});

function RouteComponent() {
  return <ReportPage />;
}
